import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from 'availity-reactstrap-validation';

import {
  Grid,
  Segment,
  Modal,
  Button,
  Icon,
  Label,
  Dropdown,
} from 'semantic-ui-react';

import { map, get } from '../../../utils/lodash';
import { EmptyContainer, CustomTable } from '../../../components';

import {
  getBroadcastNotifications,
  getAllOrganisationList,
  createBroadcastNotifications,
} from '../../../store/actions';

import './organization.scss';

class NotificationForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: true,
      organisationIds: [],
      organisationError: false,
    };
  }

  handleValidSubmit(event, values) {
    const { isChecked, organisationIds } = this.state;
    const { toggle, createBroadcastNotifications, resetPage } = this.props;
    if (!isChecked && !organisationIds.length) {
      this.setState({ organisationError: true });
    } else {
      values.isAllOrganisation = isChecked;
      values.organisationIds = organisationIds;
      delete values.organisationId;

      createBroadcastNotifications(values);
      this.form && this.form.reset();
      if (resetPage) resetPage();
      toggle();
    }
  }

  getOrganisationOptions() {
    const { allOrganisation } = this.props;
    return map(allOrganisation, (item, i) => ({
      key: item.id,
      value: item.id,
      text: item.name,
    }));
  }

  async onChangeCheckBox() {
    await this.setState((prevState) => ({
      isChecked: !prevState.isChecked,
    }));
  }

  async onChangeOrganisation(event, data) {
    this.setState({
      organisationIds: data.value,
      organisationError: !data.value.length,
    });
  }

  render() {
    const { isChecked, organisationError } = this.state;
    const { toggle, t } = this.props;
    const options = this.getOrganisationOptions();
    return (
      <AvForm
        ref={(c) => (this.form = c)}
        onValidSubmit={(event, values) => this.handleValidSubmit(event, values)}
        className="broadcast-form"
      >
        <AvField
          label={t('common.title')}
          className="org-inputs"
          name="title"
          type="text"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.title_required'),
            },
            maxLength: {
              value: 100,
            },
          }}
        />
        <AvField
          label={t('formulary.message')}
          className="org-inputs-textarea"
          name="message"
          type="textarea"
          validate={{
            required: {
              value: true,
              errorMessage: t('formulary.validation.message_required'),
            },
          }}
        />
        <AvCheckboxGroup name="isAllOrganisation">
          <AvCheckbox
            label={t('notifications.send_to_all_organisation')}
            checked={isChecked}
            onChange={(e) => this.onChangeCheckBox()}
          />
        </AvCheckboxGroup>
        {!isChecked ? (
          <div>
            <label>{t('notifications.select_organisation')}</label>
            <Dropdown
              fluid
              multiple
              search
              selection
              options={options}
              onChange={(event, data) => this.onChangeOrganisation(event, data)}
              error={organisationError}
              className="broadcast-dropdown"
            />
            {organisationError ? (
              <div className="invalid-dropdown-input">
                {t('notifications.select_organisation_is_required')}
              </div>
            ) : null}
          </div>
        ) : null}

        <div className="model-buttons">
          <Button
            className="Secondary-Button"
            type="button"
            onClick={() => toggle()}
          >
            {t('actions.cancel')}
          </Button>
          <Button
            content={t('actions.send')}
            type="submit"
            className="Primary-Button"
          />
        </div>
      </AvForm>
    );
  }
}

class CreateNotification extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { t } = this.props;
    return (
      <div className="add-goal">
        <Modal
          trigger={
            <Button
              onClick={() => this.toggle()}
              className="customColor custom-margin-goals"
            >
              <Icon name="plus circle" />
              {t('notifications.broadcast_message')}
            </Button>
          }
          size="small"
          open={modal}
          closeIcon={
            <Icon
              onClick={() => this.toggle()}
              name="close"
              className="closeicon"
            />
          }
        >
          <Modal.Header>
            {t('notifications.broadcast_new_message')}
          </Modal.Header>
          <Modal.Content>
            <NotificationForm {...this.props} toggle={() => this.toggle()} />
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

class ViewNotification extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { modal } = this.state;
    const { records, t } = this.props;
    return (
      <Modal
        trigger={
          <label className="org-checklist-actions-warn">
            {t('actions.view')}
          </label>
        }
        size="small"
        open={modal}
        onOpen={() => this.toggle()}
        closeIcon={
          <Icon
            onClick={() => this.toggle()}
            name="close"
            className="closeicon"
          />
        }
        className="view-broadcast-message"
      >
        <Modal.Header>{t('notifications.view_broadcast_message')}</Modal.Header>
        <Modal.Content className="pre-line">
          {get(records, 'message')}
        </Modal.Content>
      </Modal>
    );
  }
}

class Broadcast extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
  }

  resetPage() {
    this.setState({
      currentPage: 1,
    });
  }

  componentDidMount() {
    const { getBroadcastNotifications, getAllOrganisationList } = this.props;
    getBroadcastNotifications();
    getAllOrganisationList();
  }

  columns() {
    const { i18n, t } = this.props;
    return [
      {
        title: t('common.title'),
        render: (data) => {
          return (
            <label className="org-checklist-text">
              {get(data, 'title', '-')}
            </label>
          );
        },
      },
      {
        title: t('common.organisation'),
        width: 5,
        render: (data) => {
          return get(data, 'isAllOrganisation') ? (
            <Label color="orange" horizontal className="label-padding">
              {t('common.all_organisations')}
            </Label>
          ) : (
            map(get(data, 'organisationMessages'), (item, i) => {
              const orgName = get(item, 'organisation.name');
              return (
                <Label key={i} horizontal className="label-padding">
                  {orgName}
                </Label>
              );
            })
          );
        },
      },
      {
        title: t('common.sender'),
        render: (data) => {
          return (
            <label className="org-checklist-text">
              {get(data, 'sender.firstName', '-')} {get(data, 'sender.surname')}
            </label>
          );
        },
      },
      {
        title: t('common.created_date'),
        render: (data) => {
          return (
            <label className="org-checklist-text">
              {get(data, 'createdAt')
                ? new Intl.DateTimeFormat(i18n.language, {
                    day: 'numeric', // 1
                    month: 'long', // September
                    year: 'numeric', // 2025
                    hour: '2-digit', // 09
                    minute: '2-digit', // 05
                    hour12: true, // AM/PM (always 12h format)
                  }).format(new Date(get(data, 'createdAt')))
                : '-'}
            </label>
          );
        },
      },
      {
        title: '',
        render: (data) => {
          return (
            <div className="org-checklist-actions">
              <ViewNotification {...this.props} records={data} />
            </div>
          );
        },
      },
    ];
  }

  async broadcastPageChange(page) {
    const { getBroadcastNotifications } = this.props;
    await this.setState({ currentPage: page });
    getBroadcastNotifications(page);
  }

  render() {
    const { currentPage } = this.state;
    const { t, notificationsLoading, broadcastMessage } = this.props;

    return (
      <Segment
        className="content-segment org-checklist"
        loading={notificationsLoading.broadcast}
      >
        <Grid>
          <Grid.Row>
            <Grid.Column
              mobile={16}
              tablet={8}
              computer={8}
              textAlign="left"
              verticalAlign="bottom"
            ></Grid.Column>
            <Grid.Column mobile={16} tablet={8} computer={8} textAlign="right">
              <CreateNotification
                {...this.props}
                resetPage={() => this.resetPage()}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            {get(broadcastMessage, 'docs') && broadcastMessage.docs.length ? (
              <Grid.Column>
                <CustomTable
                  header
                  columns={this.columns()}
                  data={broadcastMessage.docs}
                  customClass="org-checklist-table"
                  pagination
                  handlePaginationChange={(page) =>
                    this.broadcastPageChange(page)
                  }
                  page={currentPage}
                  noOfPages={broadcastMessage.pages}
                  keyExtractor={(item, index) => item.id}
                />
              </Grid.Column>
            ) : (
              <EmptyContainer msg={t('notifications.no_notification_found')} />
            )}
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

const mapStateToProps = (state) => {
  const { organization, authentication, user } = state;
  return {
    user: authentication.user,
    notificationsLoading: user.notificationsLoading,
    broadcastMessage: user.broadcastMessage,
    organization: organization.organization,
    allOrganisation: organization.allOrganizations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getBroadcastNotifications,
      getAllOrganisationList,
      createBroadcastNotifications,
    },
    dispatch
  );
};

Broadcast = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Broadcast));

export { Broadcast };
